module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Rolling-pin-1a2c5a0e7e9fad877b3e4cfda8f7bf77.svg";